import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiPropertyValuationValuationBlockValueAdjustmentsConstants } from "../../../../../../../shared/constants/api-constants/api-property-valuation-valuation-block-value-adjustments.constants";
let ValuationBlockValueAdjustmentsService = class ValuationBlockValueAdjustmentsService {
    httpClient;
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getPropertyValuationValuationBlockValueAdjustments(params) {
        return this.httpClient.get(ApiPropertyValuationValuationBlockValueAdjustmentsConstants.URL, { params })
            .pipe(map(response => {
            return response.value;
        }));
    }
    addPropertyValuationValuationBlockValueAdjustment(params) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockValueAdjustmentsConstants.URL}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    patchPropertyValuationValuationBlockValueAdjustment(valuationBlockValueAdjustment, valueAdjustmentId) {
        return this.httpClient.patch(`${ApiPropertyValuationValuationBlockValueAdjustmentsConstants.URL}/${valueAdjustmentId}`, valuationBlockValueAdjustment)
            .pipe(map(response => {
            return response;
        }));
    }
    deletePropertyValuationValuationBlockValueAdjustment(requestBody) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockValueAdjustmentsConstants.URL}/${ApiPropertyValuationValuationBlockValueAdjustmentsConstants.FUNCTION_DELETE_MULTIPLE_PROPERTY_VALUATION_BLOCK_VALUE_ADJUSTMENTS}`, requestBody)
            .pipe(map(response => {
            return response;
        }));
    }
    inheritStructureBlockValueAdjustments(valuationBlockId) {
        return this.httpClient.post(`${ApiPropertyValuationValuationBlockValueAdjustmentsConstants.URL}/${valuationBlockId}/InheritValueAdjustmentsFromRun`, {})
            .pipe(map(response => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ValuationBlockValueAdjustmentsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ValuationBlockValueAdjustmentsService);
export { ValuationBlockValueAdjustmentsService };
